module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row darker fs-small font-weight-600"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('span', {
    staticClass: "ellipsisLimit"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Country:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.country))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('span', {
    staticClass: "ellipsisLimit"
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex align-items-top pl-4"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Seller:")]), _vm._v(" "), (_vm.isResevationSoldByOta) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.otaSellerName) + "\n        ")]) : (_vm.reservation.channelType >= 100 && _vm.reservation.channelType <= 102) ? _c('span', [_vm._v("Widget")]) : (_vm.canChangeSeller && !_vm.reservation.flags.isFullyInvoiced && !_vm.isRebookedReservation) ? _c('span', {
    staticClass: "top-area__seller-picker"
  }, [_c('seller-picker', {
    attrs: {
      "size": "small",
      "reservation": _vm.reservation,
      "orignalSeller": _vm.reservation.creatorAgent ? _vm.reservation.creatorAgent : _vm.reservation.creatorUserAccount,
      "hideOthers": false,
      "inlcudeWidget": true,
      "hideGetYourGuide": true,
      "hideViator": true,
      "hideAllByChannel": true
    },
    on: {
      "input": _vm.sellerChanged
    }
  })], 1) : _c('span', [_vm._v("\n            " + _vm._s(_vm.reservation.creatorAgent ? _vm.reservation.creatorAgent.brandName : _vm.reservation.creatorUserAccount ? (_vm.reservation.creatorUserAccount.name || _vm.reservation.creatorUserAccount.label) : '') + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "ellipsisLimit"
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), (_vm.getOrigins.length !== 0) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.origin),
      expression: "origin"
    }],
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex align-items-top"
  }, [_c('label', {
    staticClass: "mr-1 d-flex"
  }, [(_vm.originsRequired) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            Origin:\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "top-area__dropdown",
    class: {
      'top-area__dropdown--error': _vm.originsRequired && !_vm.reservation.originId
    },
    staticStyle: {
      "max-width": "80% !important",
      "border-radius": "5px"
    },
    attrs: {
      "options": _vm.originsOptions,
      "label": "name",
      "placeholder": "- Select origin -"
    },
    on: {
      "input": _vm.updateOrigin
    },
    model: {
      value: (_vm.selectedOrigin),
      callback: function($$v) {
        _vm.selectedOrigin = $$v
      },
      expression: "selectedOrigin"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getSegments.length !== 0) ? _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex"
  }, [_c('label', {
    staticClass: "mr-1 d-flex"
  }, [(_vm.segmentsRequired) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            Segment:\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "top-area__dropdown",
    class: {
      'top-area__dropdown--error': _vm.segmentsRequired && !_vm.reservation.segmentId
    },
    staticStyle: {
      "max-width": "80% !important",
      "border-radius": "5px"
    },
    attrs: {
      "options": _vm.segmentsOptions,
      "label": "name",
      "placeholder": "- Select Segment -"
    },
    on: {
      "input": _vm.updateSegment
    },
    model: {
      value: (_vm.selectedSegment),
      callback: function($$v) {
        _vm.selectedSegment = $$v
      },
      expression: "selectedSegment"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.notes,
        classes: 'max-width'
      }),
      expression: "{content: notes, classes: 'max-width'}"
    }],
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex align-items-top pl-4"
  }, [_c('label', {
    staticClass: "mr-1"
  }, [_vm._v("Notes:")]), _vm._v(" "), (_vm.notes) ? _c('span', {
    staticClass: "ellipsisLimit"
  }, [_vm._v(_vm._s(_vm.notes))]) : _c('span', {
    staticClass: "dark"
  }, [_vm._v("No notes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-3 d-flex align-items-top"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5490ce2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5490ce2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TopArea.vue
// module id = 1831
// module chunks = 0